import { Image, Paragraph, Text } from '@zillow/constellation-10';
import { IconEditFilled } from '@zillow/constellation-icons';
import { Box, Card, IconButton } from '@zillow/constellation-10';
import masterCardImage from '@assets/mastercard.png';
import visaImage from '@assets/visa.png';
import discoverImage from '@assets/discover.png';
import amexImage from '@assets/amex.png';
import { HiddenText } from '@common/components/HiddenText/HiddenText';

interface PaymentMethodModuleProps {
  withBackground?: boolean;
  accountLast4?: string;
  accountName?: string;
  editable?: boolean;
  displayHiddenText?: boolean;
  onClick?: () => any;
}

const PaymentMethodModule = ({
  accountName = '',
  accountLast4,
  editable,
  withBackground,
  displayHiddenText,
  onClick,
}: PaymentMethodModuleProps) => {
  const CustomContainer = ({ children }) => {
    if (withBackground) {
      return (
        <Card css={{ padding: '400' }} elevated={false}>
          {children}
        </Card>
      );
    } else {
      return <div>{children}</div>;
    }
  };
  const getCardImage = (brand: string) => {
    const cardImageMapping = {
      Visa: visaImage,
      MasterCard: masterCardImage,
      Discover: discoverImage,
      'American Express': amexImage,
    };

    return cardImageMapping[brand] ? (
      // oxlint-disable-next-line constellation/no-raw-spacing-values -- `height: 15px` falls between `350` (14px) and `400` (16px) on the numeric sizes scale
      <Image alt="card-image" css={{ height: '15px', verticalAlign: 'middle' }} src={cardImageMapping[brand]} />
    ) : null;
  };

  const handleEditClick = (e: any) => {
    e.preventDefault();
    if (onClick) {
      onClick();
    }
  };
  if (displayHiddenText) {
    return (
      <div
        style={{
          display: withBackground ? 'block' : 'inline-block',
        }}
      >
        <CustomContainer>
          <Box css={{ display: 'flex', alignItems: 'center', minHeight: 'action.xs' }}>
            <Paragraph textStyle="body-bold" className="fs-exclude">
              Payment method
            </Paragraph>
          </Box>
          <Text className="fs-exclude">
            <HiddenText visible={displayHiddenText} />
          </Text>
        </CustomContainer>
      </div>
    );
  }

  if (!editable) {
    return (
      <div
        style={{
          display: withBackground ? 'block' : 'inline-block',
        }}
      >
        <CustomContainer>
          <Box css={{ display: 'flex', alignItems: 'center', minHeight: 'action.xs' }}>
            <Paragraph textStyle="body-bold" className="fs-exclude">
              Payment method
            </Paragraph>
          </Box>
          <Box css={{ display: 'flex', alignItems: 'center', gap: 'tighter' }}>
            {getCardImage(accountName)}
            <Text className="fs-exclude">
              {accountName} •••• {accountLast4}
            </Text>
          </Box>
        </CustomContainer>
      </div>
    );
  }

  return (
    <div
      style={{
        display: withBackground ? 'block' : 'inline-block',
      }}
    >
      <CustomContainer>
        <Box css={{ display: 'flex', alignItems: 'center', gap: 'tighter', minHeight: 'action.xs' }}>
          <Box css={{ display: 'flex', alignItems: 'center', minHeight: 'action.xs' }}>
            <Paragraph textStyle="body-bold" className="fs-exclude">
              Payment method
            </Paragraph>
          </Box>
          <IconButton
            icon={<IconEditFilled />}
            title="Edit payment method"
            tone="brand"
            emphasis="bare"
            size="xs"
            shape="square"
            onClick={handleEditClick}
          />
        </Box>
        <Box css={{ display: 'flex', alignItems: 'center', gap: 'tighter' }}>
          {getCardImage(accountName)}

          <Text className="fs-exclude">
            {accountName} •••• {accountLast4}
          </Text>
        </Box>
      </CustomContainer>
    </div>
  );
};

export default PaymentMethodModule;
